import * as nav from "@/src/platforms/generic/navigation";
import * as login from "@/src/platforms/generic/login";
import * as redemptions from "@/src/platforms/generic/redemptions";
import * as global_giving from "@/src/platforms/generic/global_giving";
import * as profile from "@/src/platforms/generic/profile";
import { Notifier } from "@/src/platforms/generic/notifications";
import * as extension_banner from "@/src/platforms/generic/extension_banner";
import * as mobile_banner from "@/src/platforms/generic/mobile_banner";
import * as two_fa_verification_modal from "@/src/platforms/generic/two_fa_verification_modal";
import * as referral_program from "@/src/platforms/generic/referral_program";
import * as extension_pop_up_banner from "@/src/platforms/generic/extension_pop_up_banner";

import Rails from "@rails/ujs";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

function initializeDashboards() {
  Object.entries(flash || {}).forEach(([type, msg]) => {
    Notifier.notify(msg, type);
  });
  flash = {};

  nav.initNavigation();
  dashboardNavUI();
  nav.sidebarNavUI();
  login.initLogin();
  redemptions.initRedemptions();
  closePopupListener();
  global_giving.initGlobalGiving();
  profile.initProfile();
  extension_banner.initBanner();
  mobile_banner.initBanner();
  referral_program.initReferralProgram();
  two_fa_verification_modal.initTwoFAVerificationModal();
}

document.addEventListener("turbo:render", initializeDashboards);
document.addEventListener("DOMContentLoaded", initializeDashboards);

function dashboardNavUI() {
  if (window.location.href.includes("redemptions")) {
    $(".rewards-table .nav-link.redemptions-link").addClass("active");
  } else if (window.location.href.includes("stays")) {
    $(".rewards-table .nav-link.stays-link").addClass("active");
  } else if (window.location.href.includes("missing")) {
    $(".rewards-table .nav-link.missing-rewards-link").addClass("active");
  } else if (window.location.href.includes("extension")) {
    $(".rewards-table .nav-link.extension-bill-link").addClass("active");
  } else if (window.location.href.includes("bonus_rewards")) {
    $(".rewards-table .nav-link.bonus-rewards-link").addClass("active");
  } else {
    $(".rewards-table .nav-link.stays-link").addClass("active");
  }
}

document.addEventListener("DOMContentLoaded", function () {
  extension_pop_up_banner.initPopupExtensionBanner();
});

function closePopupListener() {
  $(document).on("click", ".js-close-popup", function () {
    $(this).closest(".popup-base").addClass("hidden");
  });
}
